// extracted by mini-css-extract-plugin
export default {"ScreenXXSMin":"(min-width: 544px)","modalContent":"G8d2c82 Ga0fcee","disableScroll":"G3982cc","bold":"G130530 G1ab278"};